/**
 * @generated SignedSource<<9e77458cde4889443c861d0d7069e28b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly date: AGG$Date | null | undefined;
  readonly fieldConfig: {
    readonly isRequired: boolean | null | undefined;
  } | null | undefined;
  readonly fieldId: string;
  readonly id: string;
  readonly name: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateReadviewFull_DateReadView">;
  readonly " $fragmentType": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef";
};
export type date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "date_issueFieldDateReadviewFull_DateReadView"
    },
    {
      "kind": "ScalarField",
      "name": "date"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "2d11e23373a2a9517c8a8ac5a6bfe366";

export default node;
